import React from 'react'

const BetaTesting = (props) => {
    const Icon = <img src='/images/icon-gear.svg' alt='Survey icon' />
    const Title = <h2 className='mt-0 mb-0 mb-lg-2 font-medium text-left'>Manage all your services here. It’s easy.</h2>
    const Desc = <p className='mb-0 font-small text-left'>My Exetel is the quickest and simplest way to manage all of your services. You can do loads of things like monitor your usage and costs, view your invoices, pay your bill or change plan. <a href='https://www.exetel.com.au/myexetel' target='_blank'>Click here to access old My Exetel</a>.</p>

    return (
        <div className='beta-testing'>
            <div className='d-none d-lg-flex p-4'>
                <div className='mr-4'>
                    {Icon}
                </div>
                <div>
                    {Title}
                    {Desc}
                </div>
            </div>
            <div className='d-lg-none p-4'>
                <div className='d-flex align-items-center'>
                    {Icon}
                    {Title}
                </div>
                {Desc}
            </div>
        </div>
    )
}

export default BetaTesting



// WEBPACK FOOTER //
// ./resources/js/auth/BetaTesting.js